import React from 'react';
import yaml from 'js-yaml';
import { Box } from 'pounceV2';
import EditorV3 from 'Components/Editor/EditorV3';
import { Schema } from 'Generated/schema';
import SchemaFieldV3, { SchemaFieldShape } from './SchemaFieldV3';

export interface SchemaDescriptorProps {
  title?: React.ReactNode;
  yamlSpec: string;
  initialExpansionLevel?: number;
  onIndicatorsChange?: (fieldPath: string, indicators: string[]) => void;
}

const SchemaDescriptorV3: React.FC<SchemaDescriptorProps> = ({
  title,
  yamlSpec,
  initialExpansionLevel = 0,
  onIndicatorsChange,
}) => {
  const fields = React.useMemo<SchemaFieldShape[]>(() => {
    try {
      const schemaAsJSON = yaml.load(yamlSpec) as Schema;
      return schemaAsJSON.fields;
    } catch {
      return undefined; // to satisfy the linter
    }
  }, [yamlSpec]);

  // If we can't parse the fields out of the YAML schema, default to displaying the YAML schema as is
  if (!fields) {
    return <EditorV3 readOnly language="yaml" data-testid="schema-editor" value={yamlSpec} />;
  }

  return (
    <Box as={title ? 'article' : 'section'}>
      {title}
      <Box as="ul" role="tree">
        {fields.map(field => (
          <Box as="li" role="treeitem" key={field.name}>
            <SchemaFieldV3
              field={field}
              initialExpansionLevel={initialExpansionLevel}
              onIndicatorsChange={onIndicatorsChange}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SchemaDescriptorV3;
